export enum DashboardGraphMetricProduct {
  ACTIVATION_POPUPS = "ACTIVATION_POPUPS",
  ABANDONMENT_MAILS = "ABANDONMENT_MAILS",
  NEWSLETTER_FORMS = "NEWSLETTER_FORMS",
  BROWSE_ABANDONMENT_MAILS = "BROWSE_ABANDONMENT",
  COME_BACK_MAILS = "COME_BACK_MAILING"
}
